/**
 * shareLinks — porta de `createShareButton`/`showShareButtons` [application.js:7895].
 * Monta a URL e a mensagem de compartilhamento (link de embaixador com desconto, ou vídeo
 * do LeadTalk/LeadMusic) e devolve o href de cada rede social.
 */
export type ShareType = 'clipboard' | 'whatsapp' | 'telegram' | 'twitter' | 'facebook' | 'linkedin';

export const SHARE_TYPES: ShareType[] = ['clipboard', 'whatsapp', 'telegram', 'twitter', 'facebook', 'linkedin'];

const SHARE_URLS = {
  telegram: 'https://t.me/share/url',
  twitter: 'https://twitter.com/intent/tweet',
  linkedin: 'https://www.linkedin.com/sharing/share-offsite/',
  whatsapp: 'https://api.whatsapp.com/send',
  facebook: 'https://www.facebook.com/sharer/sharer.php',
} as const;

/** Constrói o href de uma rede para uma URL/mensagem já resolvidas (legado 7938-7962). */
export function buildShareHref(type: ShareType, url: string, message?: string): string {
  if (type === 'whatsapp') {
    const text = message ? `${encodeURIComponent(message)}%0A%0A${encodeURIComponent(url)}` : encodeURIComponent(url);
    return `${SHARE_URLS.whatsapp}?text=${text}`;
  }
  if (type === 'telegram') {
    let href = `${SHARE_URLS.telegram}?url=${encodeURIComponent(url)}`;
    if (message) href += `&text=${encodeURIComponent(message)}`;
    return href;
  }
  if (type === 'twitter') {
    let href = `${SHARE_URLS.twitter}?url=${encodeURIComponent(url)}`;
    if (message) href += `&text=${encodeURIComponent(message)}`;
    return href;
  }
  if (type === 'facebook') return `${SHARE_URLS.facebook}?u=${encodeURIComponent(url)}`;
  if (type === 'linkedin') return `${SHARE_URLS.linkedin}?url=${encodeURIComponent(url)}`;
  return url; // clipboard
}
